import { render, staticRenderFns } from "./GesturePositionCard.vue?vue&type=template&id=97aa52ac&"
import script from "./GesturePositionCard.vue?vue&type=script&lang=ts&"
export * from "./GesturePositionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports